module.exports = __webpack_public_path__ + "img/coach.54bac350.svg";